import { useIsFocused } from '@react-navigation/native'
import { StackScreenProps } from '@react-navigation/stack'
import { useCallback, useEffect, useState } from 'react'
import { ScreenWrapper } from '../../../@ui/containers/grid/screen.wrapper'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import { ContributionStatus } from '../../../generated/graphql'
import { ReplayNavigatorParams } from '../../../navigation/types'
import { ContributionList } from '../contributions/components/contribution.list'
import { Contribution } from '../../../generated/graphql'
import { useReplayApi } from '../../../services/snapshots/replay-api.hook'
import { ContributionFilter } from '../contributions/types'
import { Row } from '../../../@ui/containers/grid/row'
import { IconButton } from 'react-native-paper'

export function ReplayPerspectiveContributionsScreen({
  route,
  navigation,
}: StackScreenProps<ReplayNavigatorParams, 'ReplayPerspectiveContributions'>) {
  const { articleId, type, status } = route.params

  const isFocused = useIsFocused()
  const globalStyles = useGlobalStyles()
  const { perspectiveService, tick } = useReplayApi()
  const [filter, setFilter] = useState<ContributionFilter>({
    status: status ?? 'All',
    type: type ?? 'All',
  })
  const [contributions, setContribution] = useState<Contribution[]>([])

  const refresh = useCallback(
    (filter: ContributionFilter) => {
      const contributions = perspectiveService.getPerspectiveContributions(
        articleId,
        filter
      )
      // This oen will not being display
      setContribution(
        contributions.filter(
          (contribution) =>
            contribution.status != ContributionStatus.Cancelled &&
            contribution.status != ContributionStatus.Censured
        )
      )
    },
    [perspectiveService, articleId]
  )

  useEffect(() => {
    refresh(filter)
  }, [tick, refresh, filter, isFocused])

  const handleFilterChange = (type: any, status: any) => {
    setFilter({ type, status })
  }

  return (
    <ScreenWrapper style={globalStyles.pageContainer}>
      <Row alignItems="center" columnGap={4}>
        <IconButton
          mode={'outlined'}
          icon="arrow-left"
          onPress={() => navigation.goBack()}
        />
      </Row>
      <ContributionList
        contributions={contributions}
        status={filter.status}
        type={filter.type}
        readonly={true}
        onFilterChange={handleFilterChange}
        onContributionPress={(contribution) => {
          navigation.navigate('ReplayContribution', {
            contributionId: contribution.id,
          })
        }}
      />
    </ScreenWrapper>
  )
}
export default ReplayPerspectiveContributionsScreen
